import React, { Component } from 'react';
import classNames from 'classnames';
import CaptchaComp from "./CaptchaComp.js";

import axios from 'axios';
import pako from 'pako';
import { ConvToString, ConvToInt, ConvToBool } from 'Common/utilsEx.js';

let OTPResendTimeout;
let FactAuthEmailResendTimeout;
import OTPUIComp from "./OTPUIComp.js";
export default class LoginForm extends Component {

    constructor(props) {
        super(props);
        this.state =
        {
            NewPwdTxt: '',
            ConfirmPwdTxt: '',
            ErrMsg: "",
            captcha: '',
            titleText: 'User Login',
            UserIdTxt: (props.LastLoggedUser || ""),
            UserPwdTxt: "",
            validatePWDChangetype: true,
            isLockOut: false,
            showFrgtPwd: (props.Settings.SendOTPForForgotPwdThrough || ""),
            showFactorAuth: (props.Settings.Enable2FactorAuth || ""),
            OTPWin: false,
            FPOTPWin: false,
            loginInfo: {},
            showPassword: false,
            userLocked: false,
            enableResend: false,
            isLiveImpexPro:_PRODUCTINFO.Title === 'LiveIMPEXPro'
        }
    }
    
    refreshCaptcha() {

        this.state.captcha = '';
        if (this.refs.CaptchaComp)
            this.refs.CaptchaComp.refreshCaptcha();
    }
    componentDidMount() {
        if(this.state.isLiveImpexPro && this.refs.txtdomain)
            this.refs.txtdomain.focus();
        else if (this.refs.txtUserId)
            this.refs.txtUserId.focus();
    }
    onNewPasswordTxtKeyPress(e) {
        if (e.charCode == 13) {
            e.preventDefault();
            this.onPasswordChangeClick();
        }
    }
    handleClickShowPassword = () => {
        this.setState({
            showPassword: !this.state.showPassword,
        });
    };
    showNewPWD(show) {

        if (typeof (show) == undefined || show == null) {
            show = false;
            this.setState({ UserPwdTxt: "" }, () => { this.refreshCaptcha() })
            axios({
                url: 'Core/Login/WebService/LoginHelper.asmx/ClearUserIdentitySession',
                method: "POST",
                data: JSON.stringify({}),
                headers: { 'Content-Type': 'application/json;charset=UTF-8' }
            })
        }
        this.setState({
            titleText: show ? 'Change Password' : 'User Login'
        }, () => {
            this.ChangePassWin(show);
            if (show) { if (this.refs.txtNewPWD) this.refs.txtNewPWD.focus(); }
            else { if (this.refs.txtUserId) this.refs.txtUserId.focus(); }
        });

    }
    ChangePassWin(show) {

        const updatedScreen = {
            showLoginDiv: !show,
            showProceedDiv: false,
            showNewPwdDiv: show
        };

        if (typeof this.props.onScreenUpdate === "function") {
            this.props.onScreenUpdate(updatedScreen);
        }

        this.setState({ OTPWin: false });
    }
    onPasswordChangeClick() {

        let newPwd = this.state.NewPwdTxt;
        let confirmPwd = this.state.ConfirmPwdTxt;
        if (newPwd == confirmPwd) {
            let webMethodUrl = 'Core/Login/WebService/LoginHelper.asmx/PasswordChangeClick';
            this.setState({ disableButtons: true });

            axios({
                url: webMethodUrl,
                method: "POST",
                data: JSON.stringify({ newPwd: newPwd, SessionKey: "" }),
                headers: { 'Content-Type': 'application/json;charset=UTF-8' }
            })
                .then(resp => {
                    let data = resp.data;
                    this.setState({ disableButtons: false });
                    if (data != null && String(data.d).length > 0) {
                        var htPwdDtl = JSON.parse(data.d);
                        if (htPwdDtl != null) {
                            var isPwdChanged = Boolean(htPwdDtl['IsPasswordChanged']);
                            var pwdChangeMsg = String(htPwdDtl['PasswordChangedMsg']);
                            alert(pwdChangeMsg);
                            if (isPwdChanged) {
                                this.setState({ UserPwdTxt: newPwd, NewPwdTxt: '', ConfirmPwdTxt: '', UserPwdTxt: '' },
                                    () => {

                                        this.refreshCaptcha();
                                        this.showNewPWD(false);
                                    });
                            }
                        }
                    }
                })
                .catch(error => {
                    this.setState({ disableButtons: false });
                    alert('error:' + error);
                })
        } else {
            alert("The new password and the confirm password needs to be same.");
        }
    }
    onUserIdTxtChange(e) {
        let uname = e.target.value;
        this.setState({ UserIdTxt: uname, ErrMsg: "", userLocked: false });
    }
    onUserDomainChange(e) {
        this.setState({ userDomain: e.target.value, ErrMsg: "" });
    }
    onPwdTxtChange(e) {
        let pass = e.target.value;
        this.setState({ UserPwdTxt: pass, ErrMsg: "", userLocked: false  });
    }
    onNewPwdChange(e) {
        this.setState({ NewPwdTxt: e.target.value, ErrMsg: "", userLocked: false  });
    }
    onConfirmPasswordTxtKeyPress(e) {
        if (e.charCode == 13) {
            e.preventDefault();
            this.onPasswordChangeClick();
        }
    }
    onConfirmPwdChange(e) {
        this.setState({ ConfirmPwdTxt: e.target.value, ErrMsg: "", userLocked: false  });
    }
    ChangePassUI() {
        return (
            <div className="headerTop-width">
                <h3 style={{ color: '#188DB2', fontSize: '1.5rem', margin: '0px' }}>{this.state.titleText}</h3>
                <div className=" form-group-margin">
                    <input ref='txtNewPWD' style={{ borderRadius: '5px', height: '2rem' }} type='password' className='userid1' autoComplete="off"
                        placeholder="New Password" tabIndex='9' value={this.state.NewPwdTxt}
                        onChange={this.onNewPwdChange.bind(this)} onKeyPress={(e) => this.onNewPasswordTxtKeyPress(e)} />
                </div>
                <div className=" form-group-margin-password">
                    <input type='password' style={{ borderRadius: '5px', height: '2rem' }} className='userid1' autoComplete="off"
                        placeholder="Confirm Password" tabIndex='10' value={this.state.ConfirmPwdTxt}
                        onChange={this.onConfirmPwdChange.bind(this)} onKeyPress={(e) => this.onConfirmPasswordTxtKeyPress(e)} />
                </div>

            </div>
        );
    }


    render() {
        try {
            if (this.state.isLockOut) {
                return (<div style={{ width: "100%", height: "190px", textAlign: "center" }}>
                    <span style={{ width: "90%", height: "180px", display: "inline-block", verticalAlign: "middle", marginTop: "20%" }}>
                        <span>{"Login from this terminal has been disabled, due to multiple failed attempts. Please try again after some time."}</span>
                    </span>
                </div>);
            }

            let headerTop = null;

            if (this.props.Screen.showNewPwdDiv)
                headerTop = <div>{this.ChangePassUI()}</div>;
            else if (this.props.Screen.showLoginDiv) {
                headerTop = <div>{this.HeaderTop0()}</div>;
            } else {
                headerTop = <div style={{ width: '362px', marginLeft: '27px' }}>{this.HeaderTopElse()}</div>;
            }

            let headerBottom = null;

            if (this.props.Screen.showLoginDiv || this.props.Screen.showNewPwdDiv) {
                headerBottom = <div>{this.HeaderBottom0()}</div>;
            } else {
                headerBottom = <div>{this.HeaderBottomElse()}</div>;
            }
            if (this.props.Screen.showNewPwdDiv || this.props.Screen.showLoginDiv) {
                return (<div className="form1">
                    <form onSubmit={(e) => e.preventDefault()}>
                        <div>{headerTop}</div>
                        <div>{headerBottom}</div>
                    </form>
					
                    {this.state.OTPWin && <OTPUIComp
                        ref="OTPComp"
                        Settings={this.props.ViewData.Settings}
                        Screen={this.props.Screen}
                        Parent={this.props.Parent}
                        enableResend={this.state.enableResend}
                        LoginForm={this}
                        FPOTPWin={this.state.FPOTPWin}
                        FrgtPwdResendClick={(event) => this.FrgtPwdResendClick(event)}
                        FrgtPwdClick={(event) => this.FrgtPwdClick(event)}
                        onClose={() => {
                            this.setState({ ...this.state, OTPWin: false, FPOTPWin: false });
                        }}
                        onSuccess={() => {
                            this.setState({ ...this.state, OTPWin: false, FPOTPWin: false });
                            this.onLoginSucess(this.state.loginInfo, true);
                        }}
                        loginInfo={this.state.loginInfo}
                    />}
                </div>
                );
            } else {
                return (<div>{headerTop}</div>)
            }
        }
        catch (ex) {
            console.log("Error in Login Form render", ex);
            throw new Error('Login Form crashed!');
        }

    }

    HeaderBottom0() {
        let ErrMsg = this.state.ErrMsg;

        var ErrMsgClass = classNames({
            ["row"]: true,
            ["msg1"]: true,
            ["msg-invisible"]: (ErrMsg.length > 0 ? false : true)
        });

        let ErrStyle = { height: "15px", textAlign: "left" }

        if (this.state.showFrgtPwd.length > 0) {
            ErrStyle = { position: "relative", width: "100%" }
        }

        return (<div>
            <div style={{display : 'flex', flexDirection: 'column'}}>
                {(!this.state.userLocked && (this.state.showFrgtPwd.length > 0) && (this.props.Screen.showNewPwdDiv === false)) &&
                <div className="FrgtPwdClass" onClick={(event) => this.FrgtPwdClick(event)}
                    tabIndex="-1" onKeyUp={(event) => this.handleKeyUp(event, "FrgtPwdClick")} >Forgot Password? </div>
                }
            </div>

            <div className="headerTop-width HeaderBottom-margin-top" style={{ verticalAlign: "top" }}>
                {this.props.Screen.showNewPwdDiv
                    ? (<div className="headerBottom-width">
                        <input style={{ width: '120px' }} id='btnChange' type='button' value='Change' className="form1-bu  "
                            tabIndex='11' disabled={this.state.disableButtons} onClick={() => this.onPasswordChangeClick()} />
                    </div>
                    )
                    : null}

                <div className="headerBottom-width headerBottom-right-align" style={(!this.props.Screen.showNewPwdDiv) ? { width: "100%", height: "50px", verticalAlign: "top" } : {}}>
                    {((ConvToBool(this.props.Settings.EnableCaptcha) == true) && !this.props.Screen.showNewPwdDiv) ?
                        <CaptchaComp
                            ref="CaptchaComp"
                            CaptchaKey={this.props.Settings.CaptchaKey}
                            onChange={(newcaptcha) => {
                                this.state.captcha = newcaptcha;
                            }}
                            onEnter={() => {
                                this.onLoginClick();
                            }}
                        /> : null}

					<div className={ErrMsgClass} style={{ textAlign: "left" }}><span>{(ErrMsg.length > 0) ? ErrMsg : "No error"}</span></div>
					<span style={{ marginTop: '5px'}}>
                    {!this.state.userLocked &&(( this.props.Screen.showNewPwdDiv)
                        ? (<input id='btnCancelPWD' type='button' value='Cancel' className="form1-bu"
                            tabIndex='12' disabled={this.state.disableButtons} onClick={() => this.showNewPWD()} />)
                        : (<button id='btnLogin' className="form1-bu" value="Log In"
                            tabIndex="4" disabled={this.IsSubmitDisabled()} onClick={() => this.onLoginClick()}>{this.getLoginCaption()}</button>))
                    }</span>
                </div>

            </div>
            <div className="row msg1 msg-invisible"><span>Error Goes Here</span></div>
            <div className="row msg1 "> <span id='LblPWBRule' style={{ foreColor: 'red', fontBold: 'false', fontSize: 'smaller' }}></span></div>
        </div>);
    }
    IsSubmitDisabled() {
        return (
            this.state.disableButtons ||
            (String(this.state.UserIdTxt || "").trim().length == 0) ||
            (String(this.state.UserPwdTxt || "").trim().length == 0) ||
            ((this.state.isLiveImpexPro) && String(this.state.userDomain || "").trim().length == 0)
        );
    }
	getLoginCaption()
	{
		if(this.state.disableButtons)
			return <span>Working...<i class="fa fa-spinner fa-spin loader"></i></span>;
		else
			return "Log In";
	}
    HeaderBottomElse() {
        return (<div className="row sign-out-button">
            <input id='btnSignOut' type='button' style={{}} className="form1-bu" value="SIGN OUT"
                tabIndex='3' onClick={() => this.onKillCurrentClick()} />
        </div>
        );
    }
    HeaderTop0() {
        return (
            <div className="headerTop-width">
                <h3 style={{ color: '#188DB2', fontSize: '1.5rem', margin: '0px' }}>Welcome!</h3>
				{this.state.isLiveImpexPro && <div className=" form-group-margin">
                    <input style={{ borderRadius: '5px', height: '2rem' }} id="txtdomain" ref="txtdomain" type='text' className='userid1'
                        placeholder="Domain" tabIndex="1" value={this.state.userDomain} onChange={this.onUserDomainChange.bind(this)} />
                </div>}
                <div className=" form-group-margin">
                    <input style={{ borderRadius: '5px', height: '2rem' }} id="txtUserId" ref="txtUserId" type='text' className='userid1'
                        placeholder="User Id" tabIndex="1" value={this.state.UserIdTxt} onChange={this.onUserIdTxtChange.bind(this)} />
                </div>
                
                <div className=" form-group-margin-password">
                    <input style={{ borderRadius: '5px', height: '2rem' }} id='txtPassword' className="userid1" type='password'
                        placeholder="Password" tabIndex="3" value={this.state.UserPwdTxt} onChange={this.onPwdTxtChange.bind(this)} />
                </div>
            </div>
        );
    }

    HeaderTopElse() {
        return (
            <div className="headerNewClass">
                <p className="headerTop-p" style={{ color: '#188DB2', marginBottom : '18px' }}>Hi {this.props.UserDetails.userName},</p>
            </div>
        );
    }

    /* header top ends */

    /* header bottom starts */
    FrgtPwdClick(event) {
        event.preventDefault()
        let { UserIdTxt } = this.state
        if (UserIdTxt === "") {
            this.setState({ ErrMsg: "Please enter the user id" })
        } else {
            this.setState({
                isFrgtPwdClicked: true,
                OTPSubmitErr: "",
                OTPTxt: "",
                enableResend: false,
            },
                () => {

                    let webMethodUrl = 'Core/Login/WebService/LoginHelper.asmx/GenerateAndSendOTP';

                    axios({
                        url: webMethodUrl,
                        method: "POST",
                        data: { UserID: UserIdTxt, UseCustomSession: false },
                        headers: { 'Content-Type': 'application/json;charset=UTF-8' }
                    }).then((res) => {
                        this.setState({ ...this.state, OTPWin: true, FPOTPWin: true });
                    });


                    if (OTPResendTimeout) {
                        clearTimeout(OTPResendTimeout);
                    }

                    OTPResendTimeout = setTimeout(() => {
                        this.setState({
                            enableResend: true,
                        })
                    }, 30000)
                })
        }
    }

    FrgtPwdResendClick(event) {
        let { enableResend } = this.state
        if (enableResend) {
            this.FrgtPwdClick(event)
        }
    }


    onKillCurrentClick() {
        window.location = window.baseUrl + 'Login/KillCurrentUserSession';
    }


    onLoginClick(killSession) {
        if ((this.state.isLiveImpexPro && String(this.state.userDomain || "").trim().length == 0) || String(this.state.UserIdTxt || "").trim().length == 0 || String(this.state.UserPwdTxt || "").trim().length == 0) {
            return;
        }
        let { userDomain, UserIdTxt, UserPwdTxt, validatePWDChangetype,captcha } = this.state
        let _data = {
            UserID: UserIdTxt,
            Password: UserPwdTxt,
            KillSession: (killSession || false),
            ValidatePWDChangetype: validatePWDChangetype,
            CaptchaCode: captcha,
            DomainID : userDomain
        };
        let binaryString = pako.gzip(JSON.stringify(_data), { to: 'string' });
        let base64Data = btoa(binaryString);
		this.setState({ disableButtons: true });


        fetch(window.baseUrl + 'Login/LoginClick', {
            method: 'POST', 
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ data: base64Data }),
        })
            .then(response => {
                if (response.redirected) {
                    window.location = response.url;
                    return;
                }
                return response.json()
            })
            .then(repdata => {
                if (repdata && repdata.data) {
                    this.setState({ disableButtons: false });
                    this.onLoginSucess(repdata.data);

                }
            })
            .catch((error) => {
                this.setState({ disableButtons: false });
                alert('error:' + error);
                console.error('Error:', error);
            });

    }

    onLoginSucess(loginInfo, OtpSucceed) {
        if (loginInfo != null) {
            this.state.loginInfo = loginInfo;
            loginInfo.Action = String(loginInfo.Action || "");
            if (loginInfo.ShowCustomWizardSetUp) {
                this.PrepareCustomWizardData(loginInfo);
                return;
            }
            switch (loginInfo.Action) {
                case "ASKKILL":
                    {
                        this.promptForKillSession('login', loginInfo.ActiveLoginSource);
                    }
                    break;
                case "TOU":
                    {
                        this.props.SetToUScreen();
                    }
                    break;
                case "PWDCHANGE":
                    {
                        this.showPWDChangeMsg(loginInfo.ActionDetails);
                    }
                    break;
                case "ISLOCKOUT":
                    {
                        this.setState({ isLockOut: true });
                    }
                    break;
                case "RELOADCAPTCHA":
                    {
                        let failMsg = ConvToString(loginInfo.FailMsg);
                        this.setState({ ErrMsg: failMsg });
                        this.refreshCaptcha();
                    }
                    break;
                case "PYMTISSUE":
                    {
                        let failMsg = ConvToString(loginInfo.FailMsg);
                        this.props.showPaymentMsgTbl(failMsg);
                    }
                    break;
                case "FAILED":
                    {

                        let failMsg = ConvToString(loginInfo.FailMsg);
                        if (ConvToBool(loginInfo.PromptMsg)) {
                            this.setState({ ErrMsg: "" }, () => { alert(failMsg); });;
                        } else {
                            if (failMsg.length === 107) {
                                this.setState({ userLocked: true })
                            } else {
                                this.setState({ userLocked: false })
                            }
                            this.setState({ ErrMsg: failMsg });
                        }


                    }
                    break;

                default:
                    {
                        if (String(loginInfo.Warn || "").length > 0) {
                            alert(loginInfo.Warn);
                        }
						
                        this.setState({ ErrMsg: "" });

                        const updatedScreen = {
                            ShowPwdChangeWindow: false,
                            mfaRegistered: loginInfo.MFARegistered
                        };

                        let updatedUserDetails = {
                            UserRoleVal: 1,
                            userRoleId: loginInfo['UserRole'],
                            userName: loginInfo['UserName'],
                            userPhoto: ConvToString(loginInfo['UserPhoto']),
                            defaultCompany: loginInfo['DefCompany'],
                            defaultLocation: loginInfo['DefLocation'],
                            userId: this.state.UserIdTxt
                        };

                        if (ConvToString(loginInfo['CompanyDetails']).length > 0) {
                            updatedUserDetails.companyDtlList = JSON.parse(loginInfo['CompanyDetails']);
                            updatedUserDetails.companyDtlList.forEach((compItem) => {
									compItem["label"] = compItem["Name"];
									compItem["value"] = compItem["CompanyID"];
                            });
                        }
                        if (ConvToString(loginInfo['LocationDetails']).length > 0) {
                            updatedUserDetails.locationDtlList = JSON.parse(loginInfo['LocationDetails']);
                        }

                        //Callback to update parent state
                        if (typeof this.props.onUpdateLoginState === "function") {
                            this.props.onUpdateLoginState(updatedScreen, updatedUserDetails);
                        }
						
                        this.setState({}, () => {
                            this.props.onLoginSuccess(); return;
							
                            //if (this.state.showFactorAuth.length > 0 && (!OtpSucceed)) {
                            //if (this.state.showFactorAuth.length > 0 && (!this.state.MFARegistered)) {
                            //    //this.openFactorAuthPopup()
                            //} else {
                            //    if (this.props.Parent.refs.ProceedForm)
                            //        this.props.Parent.refs.ProceedForm.showLoginDetailsWindow(loginInfo, () => { this.props.Parent.forceUpdate(); })
                            //}
                        });
                    }
            }
        }

    }

    PrepareCustomWizardData(loginInfo) {
        let CBDet = [];
        let companyDtlList = [];
        if (String(loginInfo['CompanyDetails']).length > 0)
             companyDtlList = JSON.parse(loginInfo['CompanyDetails']);
        let customBrokerObj = {};
        customBrokerObj['SelClearIEC'] = loginInfo.SelClearIEC;
        customBrokerObj['CHALicType'] = loginInfo.CHALicType;
        customBrokerObj['CHACompanyType'] = loginInfo.CHACompanyType;
        customBrokerObj['CHAName'] = loginInfo.CompName;
        customBrokerObj['CHAPAN'] = loginInfo.CHAPanNo;
        customBrokerObj['IsBillCompSameAsComp'] = loginInfo.IsBillCompSameAsComp;
        customBrokerObj['LICompanyID'] = companyDtlList[0].CompanyID||0;


        CBDet.push(customBrokerObj);
        let CustomWizardSetUp = {
            Show: loginInfo.ShowCustomWizardSetUp,
            CustomBrokerDet: CBDet||[]
        }
        this.props.setCustomWizardData(CustomWizardSetUp);
    }

    promptForKillSession(logType, lastLoginSource) {

        if (lastLoginSource == "App")//if user is logged in from mobile app then we do not give option to kill the session.
        {
            alert('You have logged in using Mobile device. Logout from mobile device and try again.');
            return;
        }

        if (confirm('You have logged in from another web portal,\nDo you want to kill the other session and continue?')) {

            switch (logType) {
                case 'login': this.onLoginClick(true); break;
            }
        }else{
            this.setState({disableButtons : false})
        }
    }


    showPWDChangeMsg(ActionDetails) {
        if (ActionDetails && ActionDetails.length >= 2) //pwdChangeType = 3;
        {
            let res = true;
            switch (String(ActionDetails[0] || "").toUpperCase()) {
                case "FORCEPWDCHANGE":
                    alert('Please change the password to access Logi-sys.');
                    break;
                case "PWDEXPIRE":
                    alert('Your password has expired.\nPlease change the password to access Logi-sys.');
                    break;
                case "PWDWILLEXPIRE":
                    let msg = 'Your password will expire %expiryTime%.\nWould you like to change the password?';
                    let expire_IN = (ActionDetails[1] || 0);
                    if (expire_IN > 1)
                        msg = msg.replace('%expiryTime%', 'in ' + expire_IN + ' days');
                    else
                        msg = msg.replace('%expiryTime%', 'today');

                    res = confirm(msg);
                    if (res) {
                        this.setState({ validatePWDChangetype: false });
                    }
                    else {
                        this.setState({ validatePWDChangetype: false }, () => { this.onLoginClick(); });

                    }
                    break;
            }

            if (res) {
                this.showNewPWD(true)
            }
        }
    }


    openFactorAuthPopup() {
        this.setState({ OTPWin: true });
        this.forceUpdate(() => {
            if (this.state.showFactorAuth.length > 0) {
                this.CallFactorAuthOTPService(this.state.showFactorAuth)
            }
        });
    }
    closeFactorAuthPopup() {
      /*  this.state.OTPWin = false;*/
        this.setState({ OTPWin: false });
    }
    CallFactorAuthOTPService(type) {
        let { UserIdTxt } = this.state
        let webMethodUrl = 'Core/Login/WebService/LoginHelper.asmx/GenerateAndSendOTPForAuth';

        axios({
            url: webMethodUrl,
            method: "POST",
            data: { UserID: UserIdTxt, SettingValue: type },
            headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        })

        if (FactAuthEmailResendTimeout) {
            clearTimeout(FactAuthEmailResendTimeout);
        }
        FactAuthEmailResendTimeout = setTimeout(() => {
            if (this.refs.OTPComp) {
                this.refs.OTPComp.state.enableFactorAuthEmailOTPResend = true;
                this.refs.OTPComp.forceUpdate()
            }
        }, 60000)
    }


}
